import styled, { keyframes } from 'styled-components'
import { breakpoints } from '~/assets/styles'

const lightEvenTwinkleAnimation = keyframes`
  0%, 100% {
    box-shadow: -2px -1px 5px black, 0 0 0 0 white;
  }
  50% {
    box-shadow: -2px -1px 5px black, 0 0 6px 3px white;
  }
`

const lightOddTwinkleAnimation = keyframes`
  0%, 100% {
    box-shadow: -2px -1px 5px black, 0 0 6px 3px white;
  }
  50% {
    box-shadow: -2px -1px 5px black, 0 0 0 0 white;
  }
`

export const Led = styled.div`
  background: ${({ color = '#fff' }) => color};
  border-radius: 50%;
  height: 2.5%;
  left: 50%;
  position: absolute;
  top: 94.4%;
  transform: translateX(-50%);
  transition: all 0.5s ease-in-out;
  width: 2.5%;

  @media (max-width: ${breakpoints.sm}px) {
    top: 94%;
  }
`

export const LedRingContainer = styled.div`
  inset: 0;
  position: absolute;
  z-index: 1;

  .ledEven {
    animation: ${lightEvenTwinkleAnimation} 0.8s infinite ease-in-out;
  }

  .ledOdd {
    animation: ${lightOddTwinkleAnimation} 0.8s infinite ease-in-out;
  }
`

type LedWrapperPropsType = { angle: number }

export const LedWrapper = styled.div<LedWrapperPropsType>`
  inset: 0;
  position: absolute;
  transform: rotate(${({ angle }) => angle}deg);
`
